import {
    AlertTriangle,
    Box,
    Cog,
    Droplet,
    FileText,
    Hash,
    Inbox,
    Layers,
    Leaf,
    ListChecks,
    Ruler,
    Tag,
    Target,
    Wrench,
    Zap,
    type LucideIcon,
} from "lucide-react";

/** The icon of each TBox entity type (ADR-0070). Whatever names a type shows its icon,
 * on the conversation's attribute card, in the chat's identifier chips, in the pattern
 * and column settings, in the Maschinenpark and in the ontology explorer. An attribute
 * kind without a TBox type (a ticket, an order, a customer number) has no icon.
 * A plain map, so a component can look an icon up without creating a component while
 * it renders: index it, `ONTOLOGY_TYPE_ICON[type ?? ""]`, undefined for a type without
 * an icon. */
export const ONTOLOGY_TYPE_ICON: Partial<Record<string, LucideIcon>> = {
    machine_family: Layers,
    machine_model: Box,
    machine_instance: Tag,
    component: Cog,
    part_identifier: Hash,
    procedure: ListChecks,
    tool: Wrench,
    symptom: AlertTriangle,
    failure_cause: Zap,
    specification: Ruler,
    fluid: Droplet,
    document: FileText,
    inquiry_type: Target,
    customer_input: Inbox,
    work_material: Leaf,
};
